function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "headphones",
  transform: "translate(-4.5 -4.5)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_11614",
  "data-name": "Path 11614",
  d: "M19.844,7.057A12.787,12.787,0,0,0,7.057,19.844V31.353H4.5V19.844a15.344,15.344,0,1,1,30.689,0V31.353H32.632V19.844A12.787,12.787,0,0,0,19.844,7.057Z",
  transform: "translate(0 0)",
  fill: "#fff",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_11615",
  "data-name": "Path 11615",
  d: "M27.517,22.807a2.557,2.557,0,0,1,2.557-2.557h5.115V30.48a2.557,2.557,0,0,1-2.557,2.557H30.074a2.557,2.557,0,0,1-2.557-2.557Zm-15.344,0A2.557,2.557,0,0,0,9.615,20.25H4.5V30.48a2.557,2.557,0,0,0,2.557,2.557H9.615a2.557,2.557,0,0,0,2.557-2.557Z",
  transform: "translate(0 2.152)",
  fill: "#fff"
}));

var SvgHeadphones = function SvgHeadphones(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30.689,
    height: 30.689,
    viewBox: "0 0 30.689 30.689",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHeadphones, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/headphones.54fbccea.svg";
export { ForwardRef as ReactComponent };